import type { KeyedSalarieInfoDto, RechercheSalarieMode, SalarieInfoDto } from "./RechercheSalarie.type";
import * as api from "@/features/services/demande/DemandeAllService";

type UseRechercheSalarieOptions<Mode extends RechercheSalarieMode> = { mode: Mode, idDemande: number }
export function useRechercheSalarie<Mode extends RechercheSalarieMode>(options: UseRechercheSalarieOptions<Mode>) {

  async function searchSalaries(search: string): Promise<KeyedSalarieInfoDto<Mode>[]> {
    const searchApi = options.mode === 'salaries' ? api.searchSalarie : api.searchTuteur
    return await searchApi(options.idDemande, search, { sablier: false, dialogMode: 'silent' })
      .then((items) => (items as SalarieInfoDto<Mode>[]).map(toKeyed))
  }

  // Helper
  function toKeyed(salarie: SalarieInfoDto<Mode>): KeyedSalarieInfoDto<Mode> {
    if ('adresse' in salarie) {
      return {
        ...salarie,
        key: Object.values({ ...salarie, ...(salarie?.adresse ?? {}) }).join(", "),
      }
    } else {
      return {
        ...salarie,
        key: Object.values(salarie).join(", "),
      }
    }
  }

  return {
    searchSalaries
  }

}
